import { signalStore } from '@ngrx/signals';
import { withBase } from './features/base.feature';
import { withListing } from './features/listing.feature';
import { withResponse } from './features/response.feature';

/**
 * Advanced Commerce Listing Store
 *
 * @link https://ngrx.io/guide/signals/signal-store
 *
 * !!! WARNING: ORDER OF FEATURES IS IMPORTANT - next future can read data from previous, but previous can't read data from next
 */
export const AdvancedCommerceListingStore = signalStore({ providedIn: 'root' }, withBase(), withResponse(), withListing());
